import { render, staticRenderFns } from "./IceRing63RT.vue?vue&type=template&id=49458c06&scoped=true"
import script from "./IceRing63RT.vue?vue&type=script&lang=ts"
export * from "./IceRing63RT.vue?vue&type=script&lang=ts"
import style0 from "./IceRing63RT.vue?vue&type=style&index=0&id=49458c06&prod&lang=scss&scoped=true"
import style1 from "./IceRing63RT.vue?vue&type=style&index=1&id=49458c06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49458c06",
  null
  
)

export default component.exports